import React from "react";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';


interface NumberChipProps{
  number: number;
  label: string
}

export function NumberChip(props: NumberChipProps) {
  return (
    <Chip
      avatar={<Avatar>{props.number}</Avatar>}
      variant="outlined"                        // optional
      label={
           <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
             {props.label}
             { props.number > 0 ? <TrendingUpIcon fontSize="small"/> : <TrendingFlatIcon fontSize="small"/>}
           </span>
         }
    />
  );
}
